import { render, staticRenderFns } from "./3v3pivot-icon.vue?vue&type=template&id=aa499156&"
import script from "./3v3pivot-icon.vue?vue&type=script&lang=js&"
export * from "./3v3pivot-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports